import { useState } from "react";
import "./CursoSacarLicencia.css";
import ShellCard from "../../components/ShellCard";
import floridaHandbookEs from "../../assets/images/florida-driver-license-handbook-es.png";
import slide1Img from "@/assets/images/slide-1.jpg";
import PackageCard from "../../components/PackageCard";

const locations = [
    {
        id: 1,
        name: "OFICINA CENTRAL AEROPUERTO/DORAL",
        address: "7500 N.W. 25th Street #119 Miami, FL 33122",
    },
    {
        id: 2,
        name: "ÁREA OESTE DADE/FIU",
        address: "1321 SW 107 Ave #213A Miami, FL 33174",
    },
    {
        id: 3,
        name: "CENTRO DE PRUEBAS DE MANEJO EN BROWARD",
        address: "3726 W. Oakland Park Blvd, Lauderdale Lakes, FL 33311",
    },
    {
        id: 4,
        name: "ÁREA CENTRAL DE PALM BEACH",
        address: "1993 S. Military Trail West Palm Beach, FL 33415",
    },
];

const packages = [
    {
        id: 1,
        titleLines: ["Curso de alcohol", "y drogas"],
        price: "$29.95",
        description: (
            <>
                <p>
                    El curso de Drogas y Alcohol es obligatorio para obtener la licencia
                    (Conductores noveles).
                </p>
                <p className="mt-3">Debe tener 18 años o más para inscribirse.</p>
            </>
        ),
        infoLink: "/curso-de-alcohol-y-drogas",
        registerLink: "https://courses.metrotrafficschool.com/onlinecourses/index.php/register?awc_id=Mzgz",
    },
    {
        id: 2,
        titleLines: ["Curso de", "Preparatoria"],
        price: "$19.95",
        description: (
            <>
                <p>Examen de práctica para el permiso del DMV de Florida</p>
            </>
        ),
        infoLink: "/curso-de-preparatoria",
        registerLink: "https://courses.metrotrafficschool.com/onlinecourses/index.php/register?awc_id=NTE2",
    },
    {
        id: 3,
        titleLines: ["Examen", "Teórico"],
        price: "$80.00",
        description: (
            <>
                <p className="fw-bold">Examen del DMV Supervisado en Persona</p>
                <p>
                    Para personas de 18 años o más, el examen debe ser tomado en persona en
                    cualquiera de nuestras 4 ubicaciones convenientes.
                </p>
            </>
        ),
        infoLink: "examen-teorico",
        locationLink: true,
        registerLink: "https://classroom.metrotrafficschool.com/dmv-exam-register/MzU="
    },
    {
        id: 4,
        titleLines: ["Paquete de", "Ahorro"],
        price: "$89.95",
        description: (
            <>
                <p>Curso de alcohol y drogas + Examen Teórico Permit Exam</p>
                <p className="fw-bold text-warning">AHORRA $20.00 - 18%!</p>
                <p>
                    El examen Teórico del DMV – Supervisado (En persona) debe realizarse en
                    cualquiera de nuestras 4 ubicaciones convenientes. Puedes registrarte
                    ahora y presentarte sin cita – no necesitas tener una cita.
                </p>
            </>
        ),
        locationLink: true,
        registerLink: "https://courses.metrotrafficschool.com/onlinecourses/registration/create_account?awc_id=MzIzOQ==",
    },
    {
        id: 5,
        titleLines: ["Paquete", "Completo"],
        price: "$99.95",
        description: (
            <>
                <p>
                    Curso de alcohol y drogas + Curso de preparatoria + Examen Teórico
                </p>
                <p className="fw-bold text-warning">AHORRA $29.95 - 23%!</p>
                <p>
                    El examen Teórico del DMV – Supervisado (En persona) debe realizarse en
                    cualquiera de nuestras 4 ubicaciones convenientes. Puedes registrarte
                    ahora y presentarte sin cita – no necesitas tener una cita.
                </p>
            </>
        ),
        locationLink: true,
        registerLink: "https://courses.metrotrafficschool.com/onlinecourses/registration/create_account?awc_id=MzI0MQ==",
    },
];

const CursoSacarLicencia = () => {
    const [hoveredCardId, setHoveredCardId] = useState(null);
    const [hoveredLocation, setHoveredLocation] = useState(null);

    const handleLocationHover = (packageId) => {
        setHoveredLocation(packageId);
    };

    const handleLocationLeave = () => {
        setHoveredLocation(null);
    };

    return (
        <>
            <section className="hero-slider-section">
                <div
                    className="hero-banner"
                    style={{
                        backgroundImage: `url(${slide1Img})`,
                    }}
                >
                    <div className="banner-text-container">
                        <div className="banner-heading">
                            <h1 className="banner-title mb-2">Para obtener la licencia</h1>
                            <p className="banner-subheading fs-4">
                                ELIJA UNO DE LOS PAQUETES SIGUIENTES Y ¡AHORRE DINERO!
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            <main className="curso-sacar-licencia-page">
                <div className="container py-5">
                    <div className="row justify-content-center mb-5">
                        <div className="col-12 text-center text-white">
                            <p className="lead mb-2" style={{ color: "#ff6b6b" }}>
                                Debe tener 18 años o más para inscribirse en el curso de Drogas
                                y Alcohol de 4 horas.
                            </p>
                            <p className="lead" style={{ color: "#ff6b6b" }}>
                                Si tiene entre 14 y 17 años, por favor inscríbase en el curso
                                DETS de 6 horas{" "}
                                <strong style={{ color: "#ff6b6b" }}>6-Hour DETS course</strong>.
                            </p>
                        </div>
                    </div>

                    <div className="row g-4 justify-content-center">
                        {packages.map((pkg) => (
                            <div key={pkg.id} className="col-12 col-md-6 col-lg-4 col-xl-2-4" style={{ minWidth: pkg.id > 3 ? '300px' : 'auto' }}>
                                <PackageCard
                                    pkg={pkg}
                                    hoveredCardId={hoveredCardId}
                                    setHoveredCardId={setHoveredCardId}
                                    hoveredLocation={hoveredLocation}
                                    handleLocationHover={handleLocationHover}
                                    handleLocationLeave={handleLocationLeave}
                                    locations={locations}
                                />
                            </div>
                        ))}
                    </div>

                    <div className="text-center pt-5">
                        <h3 className="text-warning">
                            ¡No tienes que esperar en línea en el Departamento de Vehículos!
                            <br />
                            ¡Haga su examen por internet ahora mismo!
                        </h3>
                    </div>

                    <div className="row mt-5">
                        <div className="col-12">
                            <ShellCard>
                                <div className="row g-5">
                                    <div className="col-12">
                                        <div className="mb-5">
                                            <h4 className="section-title">Detalles del Curso</h4>
                                            <p>
                                                Para una descripción más completa del curso de alcohol y
                                                drogas,{" "}
                                                <a href="/first-time-driver-course" className="text-warning">
                                                    por favor haga clic aquí.
                                                </a>
                                            </p>
                                            <p>
                                                Nosotros aquí en Metro Traffic School, sabemos que los
                                                jóvenes están ocupados con la escuela, actividades
                                                extracurriculares o el trabajo y los estudios. Teniendo eso
                                                en mente, hemos diseñado una versión del Curso de Alcohol y
                                                Drogas por Internet que te ofrece la flexibilidad de
                                                terminar el curso de acuerdo a tu horario.
                                            </p>
                                            <p>
                                                ¡Registrarse es fácil! Simplemente llene la información
                                                requerida en la página de inscripción, cree una contraseña y
                                                responda 10 preguntas de seguridad (estas preguntaras
                                                aparecerán al azar en el transcurso del curso, y deben de
                                                ser contestadas correctamente para validar la identidad de
                                                quien está tomando el curso)….y lo mejor de todo es que
                                                podrá empezar en cuanto se registre.
                                            </p>
                                        </div>

                                        <div className="mb-5">
                                            <h4 className="section-title">¿Cómo funciona?</h4>
                                            <p>
                                                El curso está dividido en secciones de 15-40 minutos. Usted
                                                puede entrar y salir del curso cuantas veces quiera y
                                                completarlo según su conveniencia. Para recibir crédito por
                                                una sección, debe completarla (hasta que el reloj marque
                                                cero). Habrá un examen al final del curso de 40 preguntas
                                                basado en el contenido del mismo. Debe obtener un 80% (32
                                                preguntas) correctas para recibir crédito. Garantizamos que
                                                apruebe el examen. Si necesita re tomar el examen, lo puede
                                                hacer cuantas veces necesario sin costos adicionales.
                                            </p>
                                        </div>

                                        <div className="d-flex justify-content-center pb-5">
                                            <div
                                                className="p-4 rounded text-center w-100"
                                                style={{
                                                    backgroundColor: "#252525",
                                                    borderRadius: "8px",
                                                    border: "2px solid var(--metro-yellow)",
                                                    maxWidth: "600px"
                                                }}
                                            >
                                                <div className="mb-3">
                                                    <span
                                                        className="display-5 fw-bold"
                                                        style={{ color: "var(--metro-yellow)" }}
                                                    >
                                                        $29.95
                                                    </span>
                                                </div>
                                                <p className="text-white mb-3">
                                                    Puede hacer el pago usando una tarjeta de crédito o debito a
                                                    través de nuestro método de pago seguro.
                                                </p>

                                                <div className="d-flex flex-wrap justify-content-center gap-3">
                                                    <a
                                                        href="https://courses.metrotrafficschool.com/onlinecourses/index.php/register?awc_id=Mzgz"
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="btn btn-lg px-4 py-2 fw-bold text-dark metro-btn-primary text-decoration-none"
                                                        style={{ minWidth: "200px" }}
                                                    >
                                                        Registrarme ahora!
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12">
                                    <a
                                        href="https://www.flhsmv.gov/pdf/handbooks/spanishdriverhandbook.pdf"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <img
                                            src={floridaHandbookEs}
                                            alt="Florida Driver License Handbook Spanish"
                                            className="img-fluid shadow-sm"
                                            style={{ maxHeight: "400px" }}
                                        />
                                    </a>
                                </div>
                            </ShellCard>
                        </div>
                    </div>
                </div>
            </main >
        </>
    );
};

export default CursoSacarLicencia;
